// keys
export const TOKEN_KEY = "token";
export const REFRESH_TOKEN_KEY = "refreshToken";
export const TIME_TOKEN_KEY = 'tokenTime';
export const PAY_FROM_DETAILS = "PAY_FROM_DETAILS";
// endpoints
export const AUTH_ENDPOINT = "/api/digital/security";
export const CREDITOS_ENDPOINT = "/api/digital/creditos";
export const PAGOS_ENDPOINT = "/api/digital/pagos";
export const CAMPANIAS_ENDPOINT = "/api/digital/campanias";
export const CUENTAS_ENDPOINT = "/api/digital/cuentas";
export const TRANSACTIONAL_ENDPOINT = "/api/digital/transactional";
export const TRANSFERENCIAS_ENDPOINT = "/api/digital/transferencias";

//endpoints auth
export const AUTH_ENDPOINT_LOGIN = "/api/digital/security/auth/login";
export const AUTH_V2_ENDPOINT_LOGIN = "/api/digital/security/auth/v2/login";
export const AUTH_V2_VERIFICATION_ENDPOINT_LOGIN = "/api/digital/security/auth/v2/verification";
export const AUTH_ENDPOINT_REFRESH_TOKEN = "/api/digital/security/auth/refresh-token";
export const AUTH_ENDPOINT_LOGOUT = "/api/digital/security/logout";
export const AUTH_ENDPOINT_SESSION_CLOSE = "/api/digital/security/session/close";
export const AUTH_ENDPOINT_SESSION_CLOSE_ALL = "/api/digital/security/session/close-all";
export const AUTH_ENDPOINT_GET_ALL_SESSIONS = "/api/digital/security/session/all";

// Register User
export const REGISTER_FASE_IDENTIFICATION = 1;
export const REGISTER_FASE_VALIDATION = 2;
export const REGISTER_FASE_CONFIRMATION = 3;
export const REGISTER_FASE_COMPLETED = 4;

// Recover Password
export const RECOVER_FASE_VALIDATION = 1;
export const RECOVER_FASE_CONFIRMATION = 2;
export const RECOVER_FASE_COMPLETED = 3;

//Documento de Identidad Cliente
export const CODIGO_TIPO_DOCUMENTO_DNI = "1";
export const CODIGO_TIPO_DOCUMENTO_CCEE = "2";
export const CODIGO_TIPO_DOCUMENTO_PASP = "5";
export const CODIGO_TIPO_DOCUMENTO_RUC = "6";
export const CODIGO_TIPO_DOCUMENTO_OTRS = "9";
export const CODIGO_TIPO_DOCUMENTO_PTP = "8";
export const CODIGO_TIPO_DOCUMENTO_CI = "A";
export const CODIGO_TIPO_DOCUMENTO_CR = "B";
export const CODIGO_TIPO_DOCUMENTO_CEPR = "C";

//Longitud de Numero de documentos
export const LONGITUD_TIPO_DOCUMENTO_DNI = 8;
export const LONGITUD_TIPO_DOCUMENTO_CCEE = 9;
export const LONGITUD_TIPO_DOCUMENTO_PASP = 11;
export const LONGITUD_TIPO_DOCUMENTO_RUC = 11;
export const LONGITUD_TIPO_DOCUMENTO_OTRS = 20;
export const LONGITUD_TIPO_DOCUMENTO_PTP = 9;
export const LONGITUD_TIPO_DOCUMENTO_CI = 13;
export const LONGITUD_TIPO_DOCUMENTO_CR = 9;
export const LONGITUD_TIPO_DOCUMENTO_CEPR = 9;

//Metodos de verificacion
export const CODIGO_METODO_VERIFICACION_SMS = "1";
export const CODIGO_METODO_VERIFICACION_EMAIL = "2";
export const CODIGO_METODO_VERIFICACION_PUSH = "3";

//Limite de envios de mensajes de verificacion via SMS
export const LIMITE_ENVIO_METODO_VERIFICACION_SMS = 3;

//Logitud maxima de correo
export const LONGITUD_MAXIMA_CORREO = 60;
export const LONGITUD_MAXIMA_CUENTA_CREDITO = 17;
export const LONGITUD_MINIMA_CUENTA_CREDITO = 9;
export const LONGITUD_MAXIMA_CELULAR = 9;
export const LONGITUD_MAXIMA_PASSWORD = 64;
export const LONGITUD_MINIMA_PASSWORD = 12;

//Moneda
export const CODIGO_MONEDA_SOLES = "001";
export const CODIGO_MONEDA_DOLARES = "002";
export const CODIGO_MONEDA_ISO_SOLES = "PEN";
export const CODIGO_MONEDA_ISO_DOLARES = "USD";
export const DESCRIPCION_MONEDA_SOLES = "Soles";
export const DESCRIPCION_MONEDA_DOLARES = "Dólares americanos";
export const NOMBRE_MONEDA_SOLES = "S/";
export const NOMBRE_MONEDA_DOLARES = "US$";

//Formato Fecha
export const FORMATO_PRESENTACION_FECHA_CORTA = "DD/MM/yyyy";

//Metodos de pago
export const CODIGO_METODO_PAGO_CULQI = "1";
export const CODIGO_METODO_PAGO_CUENTA_AHORROS = "2";

//Descripcion Metodo de Pago
export const DESCRIPCION_METODO_PAGO_CULQI = "Cargo tarjeta débito otro banco";
export const DESCRIPCION_METODO_PAGO_CUENTA_AHORROS = "Cargo cuenta de ahorros";

//Culqi
export const KEY_PUBLIC_CULQI = process.env.REACT_APP_KEY_PUBLIC_CULQI;

//Tipos de campanias
export const CODIGO_ORIGEN_CAMPANIA_MICRO = "1";
export const CODIGO_ORIGEN_CAMPANIA_MICASH = "2";
export const DESCRIPCION_ORIGEN_CAMPANIA_MICRO =
  "TIENES UN CRÉDITO MICRO (PRE-APROBADO)";
export const DESCRIPCION_ORIGEN_CAMPANIA_MICASH =
  "TIENES UN CRÉDITO MI CASH (PRE-APROBADO)";
export const DESCRIPCION_ORIGEN_CAMPANIA_LINEA_PRYMERA =
  "TIENES UNA LÍNEA DE PRYMERA CON UN CRÉDITO (APROBADO)";
export const SUBTITULO_ORIGEN_CAMPANIA_MICRO =
  "¡Es momento de reimpulsar tu negocio!";
export const SUBTITULO_ORIGEN_CAMPANIA_MICASH =
  "Obtén efectivo altoque para lo que desees";
export const SUBTITULO_ORIGEN_CAMPANIA_LINEA_PRYMERA =
  "Para que tu negocio siga creciendo";

//reCAPTCHA Key
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

//Grupo de productos credito
export const CODIGO_GRUPO_PRODUCTO_CONFIRMING = "2";
export const CODIGO_GRUPO_PRODUCTO_CANIA = "6";
export const CODIGOS_GRUPO_PRODUCTOS_PAGO_NO_SOPORTADOS = [
  CODIGO_GRUPO_PRODUCTO_CONFIRMING,
  CODIGO_GRUPO_PRODUCTO_CANIA,
];

//Numero de movientos default
export const NUMERO_MOVIMIENTOS_CONSULTA_DEFAULT = 10;

//Tipos de cuentas pasivos
export const CODIGO_TIPO_CUENTA_PASIVO_AHORROS = "A";
export const CODIGO_TIPO_CUENTA_PASIVO_CTS = "C";
export const CODIGO_TIPO_CUENTA_PASIVO_DPF = "P";
//Tipos de cuentas pasivas no soportadas para aperturar un DPF
export const CODIGOS_TIPO_CUENTA_NO_SOPORTADOS_APERTURAR_DPF = [
  CODIGO_TIPO_CUENTA_PASIVO_CTS,
  CODIGO_TIPO_CUENTA_PASIVO_DPF,
];

export const SALDO_MINIMO_APERTURA_CUENTA_CARGO = 1;

//Fase Apertura cuenta de ahorros
export const FASE_APERTURA_CUENTA_AHORROS_INICIAL = "1";
export const FASE_APERTURA_CUENTA_AHORROS_CONFIRMACION = "2";
export const FASE_APERTURA_CUENTA_AHORROS_COMPLETADO = "3";

//Fase Apertura cuenta DPF
export const FASE_APERTURA_CUENTA_DPF_INICIAL = "1";
export const FASE_APERTURA_CUENTA_DPF_CONFIRMACION = "2";
export const FASE_APERTURA_CUENTA_DPF_COMPLETADO = "3";

//Label Apertura de cuenta
export const LABEL_HE_LEIDO_DOCUMENTOS_CONTRACTUALES_APERTURA_CUENTA =
  "He leído los documentos contractuales y acepto las cláusulas específicas.";
export const NOMBRE_TIPO_CUENTA_AHORROS = "Ahorros";
export const NOMBRE_TIPO_CUENTA_DPF = "Plazo Fijo";

//URL documentos
export const URL_DOCUMENTO_TERMINOS_DATOS_PERSONALES =
  "https://d3nnjqhzkn1cm.cloudfront.net/documentos/T%C3%A9rminos%20y%20Condiciones.pdf";

//Mensaje validacion apertura cuenta
export const MSG_VALIDATE_ACEPTAR_CLAUSULAS_CONTRACTUALES =
  "Debe aceptar los términos y condiciones";
export const MSG_VER_TERMINOS_CONDICIONES = "Ver términos y condiciones";

//Apertura DPF
export const LONGITUD_MAXIMA_IMPORTE = 12;
export const MONTO_MINIMO_APERTURA_DPF_NATURAL_SOLES = 350;
export const MONTO_MINIMO_APERTURA_DPF_NATURAL_DOLARES = 350;
export const MONTO_MINIMO_APERTURA_DPF_JURIDICO_SOLES = 500;
export const MONTO_MINIMO_APERTURA_DPF_JURIDICO_DOLARES = 500;
export const LONGITUD_MAXIMA_PLAZO = 6;
export const VALOR_MINIMO_PLAZO = 30;
export const VALOR_MAXIMO_PLAZO = 999999;

//Tipo Persona
export const TIPO_PERSONA_NATURAL = "N";
export const TIPO_PERSONA_JURIDICO = "J";

//Fases - Transferencias entre cuentas propias
export const FASE_TRANSFERENCIA_ENTRE_CUENTAS_PROPIAS_INICIAL = "1";
export const FASE_TRANSFERENCIA_ENTRE_CUENTAS_PROPIAS_VALIDACION = "2";
export const FASE_TRANSFERENCIA_ENTRE_CUENTAS_PROPIAS_PROCESADO = "3";

//Fases - Transferencias entre cuentas prymera
export const FASE_TRANSFERENCIA_ENTRE_CUENTAS_PRYMERA_INICIAL = "1";
export const FASE_TRANSFERENCIA_ENTRE_CUENTAS_PRYMERA_VALIDACION = "2";
export const FASE_TRANSFERENCIA_ENTRE_CUENTAS_PRYMERA_PROCESADO = "3";

//Fases - Transferencias entre cuentas ifis
export const FASE_TRANSFERENCIA_ENTRE_CUENTAS_IFIS_INICIAL = "1";
export const FASE_TRANSFERENCIA_ENTRE_CUENTAS_IFIS_VALIDACION = "2";
export const FASE_TRANSFERENCIA_ENTRE_CUENTAS_IFIS_PROCESADO = "3";

//Cuenta de ahorros Prymera
export const LONGITUD_MINIMA_CUENTA_AHORROS_PRYMERA = 11;
export const LONGITUD_MAXIMA_CUENTA_AHORROS_PRYMERA = 17;

//Constantes
export const RESPONSE_MESSAGE_CODE_SUCCESS = "1";
export const RESPONSE_MESSAGE_CODE_WARKING = "2";
export const RESPONSE_MESSAGE_CODE_INFO = "3";

//Clave SMS
export const LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR = 6;

//Codigos de cuentas interbancarias
export const LONGITUD_MINIMA_CCI = 10;
export const LONGITUD_MAXIMA_CCI = 20;

//Logitud nombres y apellidos destinatario
export const LONGITUD_MAXIMA_APELLIDOS_NOMBRES_DESTINATARIO = 100;

//Indicador cuenta propia
export const INDICADOR_CUENTA_PROPIA_TRANSFERENCIA_IFIS_TRUE = "1";
export const INDICADOR_CUENTA_PROPIA_TRANSFERENCIA_IFIS_FALSE = "0";

//Codigos de bancos (microbank)
export const CODIGO_BANCO_BCP = 1;
export const CODIGO_BANCO_SCOTIABANK = 7;

//Label Clave Doble Factor
export const LABEL_CONFIRMAR_OPERACION_CLAVE_DOBLE_FACTOR =
  "Para confirmar la operación, ingresa la clave que te enviamos a tu celular";
export const LABEL_INGRESE_CLAVE_DOBLE_FACTOR = "Ingresa la clave enviada";
export const MESSAGE_VALIDACION_CLAVE_DOBLE_FACTOR = "Debes ingresar la clave enviada";

//Codigos de verificacion longitud
export const LONGITUD_MAXIMA_CODIGO_VERIFICACION = 6;

//Menu Movil - Desktop
export const MENU_INICIO_CONTENT = "Inicio";
export const MENU_MIS_OFERTAS_CONTENT = "Mis ofertas";
export const MENU_CONSULTAS_CONTENT = "Consultas";
export const MENU_OPERACIONES_CONTENT = "Operaciones";
export const MENU_MIS_OFERTAS_SM_CAMPANIAS_CONTENT = "Mis campañas";
export const MENU_CONSULTAS_SM_CUENTAS_CONTENT = "Mis cuentas";
export const MENU_CONSULTAS_SM_CREDITOS_CONTENT = "Mis préstamos";
export const MENU_OPERACIONES_SM_PAGOS_CONTENT = "Realiza tus pagos";
export const MENU_OPERACIONES_SM_APERTURA_CONTENT = "Apertura tus cuentas";
export const MENU_OPERACIONES_SM_TRANSFERENCIAS_CONTENT =
  "Realiza tus transferencias";
//export const MENU_SEGURIDAD_CLAVE_SMS_CONTENT = "Clave SMS";
export const MENU_SEGURIDAD_SESIONES_CONTENT = "Ver sesiones";
export const MENU_SEGURIDAD_LOGOUT_CONTENT = "Salir";

//Validacion Programa Estado
export const MSG_VALIDACION_CLIENTE_FONDOS_PROPIOS_PROGRAMA_ESTADO =
  "Debe aceptar que los fondos para el pago del crédito son propios.";

//Tiempos para modelo refresh token
export const TIEMPO_MAXIMO_INACTIVIDAD = 1000 * 60 * 5;
export const TIEMPO_PARA_EJECUTAR_ACCION = 30000;
export const TIEMPO_VALIDACION_PRORROGA_REFRESH_TOKEN = 60000;

//Mensajes
export const MSG_SISTEMA_NO_DISPONIBLE =
  "Tenemos un inconveniente, por favor intentelo nuevamente.";
export const MSG_SESION_EXPIRADA =
  "Tu sesión ha expirado, por favor ingresa nuevamente.";
export const MSG_LOADING_GENERICO = "Por favor espere...";

//React Toastify ID
export const TOAST_ID_MSG_SESION_EXPIRADA = 1;

//Tipos ReCaptcha
export const TIPO_RECAPTCHA_V3 = "v3";

//Headers
export const REQUEST_HEADER_CHANNEL = "W";

// Codigo de tipo de proceso de auditoria
export const CODIGO_TIPO_PROCESO_AUDITORIA_APERTURA_CUENTA_AHORROS = 1;
export const CODIGO_TIPO_PROCESO_AUDITORIA_APERTURA_CUENTA_DPF = 2;
export const CODIGO_TIPO_PROCESO_AUDITORIA_TRANSFERENCIAS_OTRAS_CUENTAS = 3;
export const CODIGO_TIPO_PROCESO_AUDITORIA_TRANSFERENCIAS_OTROS_BANCOS = 4;

export const CULQI_CHECKOUT_LINK = 'https://js.culqi.com/checkout-js';
export const TIME_TOKEN_VALIDATE = 15 * 60 * 1000;
